import React, { Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Grid, Chip } from "@material-ui/core";
import styles from "../setting.module.css";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import Avatar from "@mui/material/Avatar";
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";
import { useSelector } from "react-redux";
import CoachManagementModalForAdmin from "./coachManagementForAdmin";
import CoachManagementModalForSuperAdmin from "./coachManagementForSuperAdmin";
import {
  centeredModalBoxSx,
  modalBackdropProps,
} from "../../../utils/styles/modal.overlay";

const commonModalSx = centeredModalBoxSx({
  height: 700,
  p: 4,
});

const styleForAdmin = { ...commonModalSx, width: 1000 };
const styleForCoach = { ...commonModalSx, width: 810 };
const styleForSuperAdmin = { ...commonModalSx, width: 1050 };

export default function CoachManagementModal(props) {
  const axios = useAxiosPrivate();
  const role = useSelector((state) => state.auth.role);
  const { setOpen, open } = props;
  const [data, setData] = useState([]);
  const [displayMessage, setDisplayMessage] = useState({
    show: false,
    message: "",
  });

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [open]);

  const loadData = async (e) => {
    try {
      const { data } = await axios.get("/team/admins");
      const filterData = data?.data;

      const sortByFirstName = (a, b) => {
        const nameA = (a.first_name || "").toLowerCase();
        const nameB = (b.first_name || "").toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      };

      const filterDataBySuperAdmin = filterData
        .filter(
          (item) =>
            item?.role === "SUPER_ADMIN" && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      const filterDataByAdmin = filterData
        .filter(
          (item) => item?.role === "ADMIN" && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      const filterDataByCoach = filterData
        .filter(
          (item) =>
            ["USER", "COACH"].includes(
              item?.role
            ) && item?.user_status === "ACTIVE"
        )
        .sort(sortByFirstName);

      setData([
        ...filterDataBySuperAdmin,
        ...filterDataByAdmin,
        ...filterDataByCoach,
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="coach-management-modal-title"
        aria-describedby="coach-management-modal-description"
        BackdropProps={modalBackdropProps}
      >
        <Box
          sx={
            role === "USER"
              ? styleForCoach
              : role === "ADMIN"
              ? styleForAdmin
              : styleForSuperAdmin
          }
        >
          <Grid container>
            <Grid
              item
              md={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ModalCloseButton
                style={{ position: "static" }}
                onClick={() => setOpen(false)}
              />
            </Grid>
            <Grid
              item
              md={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <p className={styles.CoachManagementTopText}>Team Staff Management</p>
            </Grid>
            {displayMessage?.show && (
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <p className={styles.CoachManagementNotificationText}>
                  {displayMessage?.message}
                </p>
              </Grid>
            )}
          </Grid>
          {role === "USER" ? (
            <>
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid container style={{ width: "40.5rem" }}>
                  <Grid
                    item
                    md={4}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p className={styles.tittleText}>Name</p>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <p className={styles.tittleText}>Email</p>
                  </Grid>
                  <Grid
                    item
                    md={2}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p className={styles.tittleText}>Level</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box className={styles.boxCSS}>
                  {data.map((item) => (
                    <Fragment key={item.id}>
                      <Grid container style={{ marginTop: "1rem" }}>
                        <Grid
                          item
                          md={1}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            alt="Remy Sharp"
                            src={item.avatar_url}
                            sx={{ width: 35, height: 35 }}
                          />
                        </Grid>
                        <Grid
                          item
                          md={3}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Grid container>
                            <Grid
                              item
                              md={12}
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <p className={styles.tittleTextData1}>
                                {item?.first_name ?? "-"}
                              </p>
                            </Grid>
                            <Grid
                              item
                              md={12}
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <p className={styles.tittleTextData2}>
                                {item?.last_name ?? "-"}
                              </p>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          md={6}
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <p className={styles.tittleTextData}>{item?.email}</p>
                        </Grid>
                        <Grid
                          item
                          md={2}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            label={
                              item?.role === "SUPER_ADMIN"
                                ? "Super Admin"
                                : item?.role === "ADMIN"
                                ? "Admin"
                                : item?.role === "COACH"
                                ? "Team Staff"
                                : "User"
                            }
                            size="small"
                            style={{
                              backgroundColor: "var(--primary-button-background-color)",
                              color: "var(--primary-button-text-color)",
                              padding: "0.5rem 0.5rem 0.5rem 0.5rem",
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container style={{ marginTop: "1rem" }}>
                        <Grid item md={12}>
                          <hr
                              style={{
                                  border: "none",
                                  borderTop:
                                      "1px solid var(--primary-popup-stroke-color)",
                              }}
                          />
                        </Grid>
                      </Grid>
                    </Fragment>
                  ))}
                </Box>
              </Grid>{" "}
            </>
          ) : role === "SUPER_ADMIN" ? (
            <CoachManagementModalForSuperAdmin
              data={data}
              loadData={loadData}
              setDisplayMessage={setDisplayMessage}
            />
          ) : (
            <CoachManagementModalForAdmin
              data={data}
              loadData={loadData}
              setDisplayMessage={setDisplayMessage}
            />
          )}
        </Box>
      </Modal>
    </div>
  );
}
